<div class="main-container">
    <div class="top-section">
        <div class="title">
            <div class="str-icon">
             <mat-icon svgIcon="structure"></mat-icon>
            </div>
            <h1 class="font-poppins">{{ "structure.heading.myStructures" | translate }}</h1>
        </div>
        <p>{{ " Track your rewards and redeem exciting toy offers." }}</p>
    </div>

    <div class="bottom-section">
        <div class="bottom-head-section">
        <div class="search-btn-section" *ngIf="structures.totalCount">
            <div class="search-contain">
                 <app-search-bar
                    [placeholder]="'genericDialogBox.placeHolder.searchStructure' | translate"
                    [initialValue]="searchQuery"
                    [debounceTime]="500"
                    (search)="triggerSearch($event)"
                    [suffixCloseIcon]="'close'"
                    [suffixSearchIcon]="'search'"
                >
                 </app-search-bar>
            </div>

            <div class="checkbox-contain">
                <mat-checkbox
                [checked]="isAllSelected"
                class="custom-checkbox"
                [indeterminate]="isIndeterminate"
                (change)="onToggleSelectAll($event)"
            >
                </mat-checkbox>
                <p (click)="onSelectAllButtonClick()">
                    {{
                        isAllSelected
                            ? ("structure.button.unselectAllBtn" | translate)
                            : ("structure.button.selectAllBtn" | translate)
                    }}
                </p>
            </div>
              
              <div class="pub-dlt-btn" *ngIf="showSelectAllCheckbox">
                <button  [disabled]="!selectedStructureIds.size" class="btn pub-btn" (click)="onBulkPublish()">
                   <mat-icon svgIcon="publish" ></mat-icon>  {{ "structure.button.publishBtn" | translate }}
                </button>
                <button
                 class="btn dlt-btn"
                    [disabled]="!selectedStructureIds.size"
                    (click)="onBulkDelete()"
                >
                 <mat-icon svgIcon="delete" ></mat-icon>   {{ "structure.button.deleteBtn" | translate }}
                </button>   
            </div>

        </div>
            <div class="filter-section" *ngIf="structures.totalCount">
                <mat-form-field class="custom-filter-section dense-3" appearance="outline">
                    <mat-select
                        placeholder="All"
                        [(value)]="selectedStatus"
                        (selectionChange)="filterStatus($event.value)"
                    >
                        @for (statusOption of statusOptions; track statusOption) {
                        <mat-option [value]="statusOption">{{ statusOption }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon matSuffix>filter_alt</mat-icon>
                </mat-form-field> 
            </div>

        </div>

        <div class="structure-list-section">
            <div class="spinner-container" *ngIf="loading">
                <mat-spinner class="loading-spinner" [diameter]="70"></mat-spinner>
            </div>
            <app-my-structures-list
                *ngIf="structures"
                [structures]="structures"
                [selectedStructureIds]="selectedStructureIds"
                [loadingStructure]="loading"
                (structureUpdated)="onStructuresUpdated([$event])"
                (structureDeleted)="onStructuresDelete($event)"
                (loadMore)="loadMoreMyStructures()"
                (checkboxToggled)="onStructureCheckboxToggled($event)"
            ></app-my-structures-list>
        </div>
    </div>
</div>
